<!--
 * @Author: Nie Wie
 * @Date: 2020-03-25 11:09:24
 * @LastEditors: Nie Wie
 * @LastEditTime: 2020-03-26 11:10:21
 * @Description: 监测季报
 -->

<template>
  <div class="season-part">
    监测季报
  </div>
</template>

<script>
export default {

}
</script>

<style>
.season-part {
  font-size: 20px;
}
</style>
